// ✅ Currency Formatter (default NGN, but configurable)
export const formatCurrency = (amount, currency = "NGN", locale = "en-NG") =>
  new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(amount);

// ✅ Date Formatter (e.g., "12 Sept 2025")
export const formatDate = (date, locale = "en-NG", options = {}) => {
  if (!date) return "";
  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
    ...options,
  }).format(new Date(date));
};

// ✅ DateTime Formatter (e.g., "12 Sept 2025, 04:30 PM")
export const formatDateTime = (date, locale = "en-NG") => {
  if (!date) return "";
  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(new Date(date));
};

// ✅ Number Formatter with commas (e.g., 1200000 → "1,200,000")
export const formatNumber = (num, locale = "en-NG") =>
  new Intl.NumberFormat(locale).format(num);

// ✅ Truncate Text (with ellipsis)
export const truncateText = (text, maxLength = 100) => {
  if (!text) return "";
  return text.length > maxLength ? `${text.slice(0, maxLength)}…` : text;
};

// ✅ Percentage Formatter (0.25 → "25%")
export const formatPercentage = (value, fractionDigits = 0) =>
  `${(value * 100).toFixed(fractionDigits)}%`;
